import { ServiceModuleType } from '@/api/model/serviceModuleType'
import { TextServiceModuleDialog } from '../open-components/text/TextServiceModuleDialog'
import { UrlServiceModuleDialog } from '../open-components/url/UrlServiceModuleDialog'
import { FileServiceModuleDialog } from '../open-components/file/FileServiceModuleDialog'
import { PersonalDocumentsPage } from '../open-components/personal-documents/PersonalDocumentsPage'
import { CalendarServiceModulePage } from '../open-components/calendar/CalendarServiceModulePage'
import { LeaderboardServiceModulePage } from '../open-components/leaderboard/LeaderboardServiceModulePage'
import { AbsenceServiceModulePage } from '../open-components/absence/AbsenceServiceModulePage'
import { TimeTrackingServiceModulePage } from '../open-components/timetracking/TimeTrackingServiceModulePage'
import { StatusServiceModulePage } from '../open-components/status/StatusServiceModulePage'
import type { ServiceModuleModel } from '@/api/model'
import {InsuranceServiceModulePage} from "@/pages/service-modules/open-components/insurance/InsurancePage.tsx";

interface Props {
  module: ServiceModuleModel
  onClose: () => void
}

/**
 * Dispatches opening a card depending on the module type. Each type opens something
 * different: Text/URL/File → dialog (overlay), PersonalDocuments → own page
 * (replaces the grid, URL-driven via `?open` — see `ServiceModulesPage`).
 * Page types are additionally listed in `IMPLEMENTED_PAGE_TYPES`. A new type = a branch here
 * (+ for page types the entry in the set).
 */
export function OpenServiceModule({ module, onClose }: Props) {
  switch (module.type) {
    case ServiceModuleType.Text:
      return <TextServiceModuleDialog module={module} onClose={onClose} />
    case ServiceModuleType.Url:
      return <UrlServiceModuleDialog module={module} onClose={onClose} />
    case ServiceModuleType.File:
      return <FileServiceModuleDialog module={module} onClose={onClose} />
    case ServiceModuleType.PersonalDocuments:
      return <PersonalDocumentsPage module={module} />
    case ServiceModuleType.Calendar:
      return <CalendarServiceModulePage module={module} />
    case ServiceModuleType.Leaderboard:
      return <LeaderboardServiceModulePage module={module} />
    case ServiceModuleType.Absence:
      return <AbsenceServiceModulePage module={module} />
    case ServiceModuleType.Timetracking:
      return <TimeTrackingServiceModulePage module={module} />
    case ServiceModuleType.StatusSystem:
      return <StatusServiceModulePage module={module} />
    case ServiceModuleType.Insurance:
      return <InsuranceServiceModulePage module={module} />
    default:
      return null
  }
}

/** Module types that open as their own page and are already implemented. */
export const IMPLEMENTED_PAGE_TYPES = new Set<ServiceModuleType>([
  ServiceModuleType.PersonalDocuments,
  ServiceModuleType.Calendar,
  ServiceModuleType.Leaderboard,
  ServiceModuleType.Absence,
  ServiceModuleType.Timetracking,
  ServiceModuleType.StatusSystem,
  ServiceModuleType.Insurance
])
